/** Чем подписать человека в пикере: имя, иначе почта, иначе id. */
export function creatorLabel(user: { name?: string | null; email?: string | null; id?: string }): string {
    const name = user.name?.trim();
    if (name) return name;
    const email = user.email?.trim();
    if (email) return email;
    return user.id ?? "";
}
